<app-page-wrapper>
  <div class="idv-wrapper">
    <app-heavy-header title="Verify Identity"></app-heavy-header>
    <div class="message-row">
      <app-spinner *ngIf="!error"></app-spinner>
      <div class="message">{{activityMessage}}</div>
    </div>
    <div class="verify-content" *ngIf="error">
      <app-alert-message type="error" mt="12px">{{ error }}</app-alert-message>
      <app-text-button (handleClick)="onClickRetry()" mt="14px" text="Try Again"></app-text-button>
    </div>
  </div>
</app-page-wrapper>